import React, { useEffect, useState } from "react";
import { useParams, Link, useNavigate } from "react-router-dom";
import "./index.css";
import useQuestsAPI from "../../../hooks/useQuestsAPI";
import { dateFormated } from "./utils";
import TaskSection from "./components/TaskSection";
import { useAuth0 } from "@auth0/auth0-react";
import searchTable, { findPayeed, sortedPrizes } from "./utils";
import { Button } from "react-bootstrap";
import { useRamadan } from "../../../context/RamadanContext";
import useGetRegistrationsAPI from "../../../hooks/useGetRegistrationsAPI";
import { useSelector } from "react-redux";
const QuestView = () => {
  const { isRamadan } = useRamadan();
  const { auth } = useSelector((state) => state.auth);

  const { id } = useParams(); // get quest id from QuestList page
  const navigate = useNavigate();
  const { isLoading, data, error } = useQuestsAPI(id);
  const { user } = useAuth0();
  const isAdmin = user.role === "admin";
  const [isUserRegistered, setIsUserRegistered] = useState(false);
  //console.log("data: ", data.type);
  const registrations = useGetRegistrationsAPI(id, { userId: auth.user.id });
 
  //console.log(registrations.length)
      console.log(isUserRegistered);

  useEffect(() => {
  if (!registrations.isLoading && !registrations.error) {
    const isRegistered = registrations.data.length > 0; // true if user is registered
    setIsUserRegistered(isRegistered);
  }
}, [registrations, isLoading, error]);

  // Handle if user enter invalid id in url
  const res = error ? error.response : null;
  useEffect(() => {
    if (res && res.status === 404) {
      navigate("/page-error-404");
    }
  }, [res, navigate]);
  const winnersDivColor = ["#ec10106b", "#0aa0e791", "rgb(76 175 80 / 56%)"];
  return (
    <>
      <div className="d-flex align-items-center mb-4 flex-wrap justify-content-end">
        <Button
          className="me-2"
          variant="outline-primary btn-rounded"
          onClick={() => navigate("/quest-list")}
        >
          <i className="fa-solid fa-chevron-left"></i>{" "}
          <span style={{ margin: "0 10px" }}>Back</span>
        </Button>
      </div>
      {isLoading ? (
        <div className="d-flex justify-content-center">
          <div className="spinner-border" role="status"></div>
        </div>
      ) : (
        <div className="quest-view">
          <div className="overview">
            {(data.prizes && findPayeed(data.prizes) && !data.isHiring) && (
              <div className="overview">
                <div style={{maxWidth: "360px"}}>
                  <div
                    className="card p-0"
                    style={{ borderRadius: "12px", overflow: "hidden" }}
                  >
                    {/* Header */}
                    <div
                      className="card-header border-0 p-4 text-white"
                      style={{
                        backgroundColor: "rgb(23, 31, 54)",
                        borderRadius: "12px 12px 0 0",
                        display: "flex",
                        justifyContent: "center",
                      }}
                    >
                      <div className="d-flex align-items-center gap-3">
                        {/* Icon on the left */}
                        <div
                          className="d-flex align-items-center justify-content-center"
                          style={{
                            width: "48px",
                            height: "48px",
                            backgroundColor: "rgba(255, 255, 255, 0.1)",
                            borderRadius: "8px",
                          }}
                        >
                          <img
                            src="/icons8-prize-50.png"
                            alt="Prize Icon"
                            style={{ width: "28px", height: "28px" }}
                          />
                        </div>

                        {/* Title and subtitle on the right */}
                        <div>
                          <div className="d-flex align-items-center gap-2">
                            <span style={{ fontSize: "20px" }}>🎉</span>
                            <h4 className="fs-18 mb-0 fw-bold text-white">
                              Quest Winners
                            </h4>
                            <span style={{ fontSize: "20px" }}>🎉</span>
                          </div>
                          <small className="mt-1 d-block" style={{color: "#ffe6bb !important", fontWeight: 500}}>
                            Congratulations to our top performers!
                          </small>
                        </div>
                      </div>
                    </div>

                    {/* Winners List */}
                    <div className="p-3">
                      {sortedPrizes(data.prizes).map((prize, index) =>
                        prize.payee && prize.payee.id ? (
                          <div
                            key={prize.payee.id}
                            className="winner-item p-3 mb-3"
                            style={{
                              backgroundColor:
                                prize.rank === "1" ? "#fff7e5" 
                                : prize.rank === "2" 
                                ? "#f8f9fa" : "#fffce5",
                              borderRadius: "8px",
                              border:
                                prize.rank === "1"
                                  ? "1px solid #fff289"
                                  : prize.rank === "2"
                                  ? "1px solid #e0e0e0"
                                  : "1px solid #ffd46d",
                              position: "relative",
                            }}
                          >
                            {/* Winner Info Row */}
                            <div style={{marginTop: "1.5rem"}}>
                              <div className="d-flex align-items-center gap-3">
                                {/* Avatar with Rank Circle */}
                                <div className="position-relative">
                                  <div
                                    className="d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "45px",
                                      height: "45px",
                                      borderRadius: "50%",
                                      background:
                                        prize.rank === "1"
                                          ? "#ebb701"
                                          : prize.rank === "2"
                                          ? "#686868"
                                          : "#ed943b",
                                      color: "white",
                                      fontSize: "12px",
                                      fontWeight: "bold",
                                      border: `2px solid ${
                                        prize.rank === "1"
                                          ? "#FFD700"
                                          : prize.rank === "2"
                                          ? "#cccccc"
                                          : "#ffc100"
                                      }`,
                                    }}
                                  >
                                    {<img style={{ borderRadius: "50%", width: "100%", height: "100%", objectFit: "cover" }} src={prize.payee.avatar} alt={prize.payee.nickname} />}
                                  </div>
                                  
                                  {/* Rank Number Circle */}
                                  <div
                                    className="position-absolute d-flex align-items-center justify-content-center"
                                    style={{
                                      width: "18px",
                                      height: "18px",
                                      borderRadius: "50%",
                                      background:
                                        prize.rank === "1"
                                          ? "#ebb701"
                                          : prize.rank === "2"
                                          ? "#686868"
                                          : "#ed943b",
                                      color: "#fff",
                                      fontSize: "0.6rem",
                                      fontWeight: "bold",
                                      bottom: "-3px",
                                      right: "-1px",
                                      border: "1px solid white",
                                      boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                                    }}
                                  >
                                    {prize.rank === "1"
                                      ? "1"
                                      : prize.rank === "2"
                                      ? "2"
                                      : "3"}
                                  </div>
                                </div>

                                {/* Name and Prize */}
                                <div>
                                  <span className="mb-0" style={{fontSize: "1rem", lineHeight: "2rem", fontWeight: "600", color: "#3a3a3a"}}>
                                    {prize.payee.nickname}
                                  </span>
                                  <div className="d-flex align-items-center gap-2" style={{fontSize: ".8rem", lineHeight: "2rem", fontWeight: "600"}}>
                                    <span className="d-flex" style={{fontSize: "0.795rem", gap: '.3rem', alignItems: "center", fontWeight: "500"}}>     
                                      <span style={{ fontWeight: "700", fontSize: "1.02rem", color: "#3a3a3a"  }}>{prize.value}</span>
                                      {prize.currency === "EGP" && " EGP"}
                                      {prize.currency === "USD" && "USD"}
                                    </span>
                                  </div>
                                </div>
                              </div>

                              {/* Place Badge */}
                              <span
                                className="badge px-3 py-2"
                                style={{
                                  background:
                                    prize.rank === "1"
                                      ? "linear-gradient(to right, #ffd700, #b8860b)"
                                      : prize.rank === "2"
                                      ? "linear-gradient(to right, #dddddd, #5e5e5e)"
                                      : "linear-gradient(to right, #ffc709, #d37f3e)",
                                  color: "#fff",
                                  fontSize: ".925rem",
                                  borderTopLeftRadius: "0px",
                                  borderTopRightRadius: "6px",
                                  borderBottomLeftRadius: "6px",
                                  borderBottomRightRadius: "0px",
                                  position: "absolute",
                                  top: "0px",
                                  right: "-1px",
                                  border: "none",
                                  outline: "none",
                                  fontWeight: "600",
                                }}
                              >
                                {prize.rank === "1" ? (
                                  <div
                                    className="d-flex"
                                    style={{ gap: "8px", alignItems: "center" }}
                                  >
                                    <img
                                      src="/game.png"
                                      alt="1st winner"
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                    <span>1st Place</span>
                                  </div>
                                ) : prize.rank === "2" ? (
                                  <div
                                    className="d-flex"
                                    style={{ gap: "8px", alignItems: "center" }}
                                  >
                                    <img
                                      src="/medal.png"
                                      alt="2nd winner"
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                    <span>2nd Place</span>
                                  </div>
                                ) : (
                                  <div
                                    className="d-flex"
                                    style={{ gap: "8px", alignItems: "center" }}
                                  >
                                    <img
                                      src="/medal-2.png"
                                      alt="3rd winner"
                                      style={{ width: "20px", height: "20px" }}
                                    />
                                    <span>3rd Place</span>
                                  </div>
                                )}
                              </span>
  
                            </div>
                          </div>
                        ) : null
                      )}
                    </div>
                  </div>
                </div>
              </div>
            )}

            <div className="overview">
              <div>
                <div className="card p-4">
                  <div className="card-header border-0 pb-3 px-0 pt-0 ">
                    <h4 className="fs-20">Overview</h4>
                  </div>
                  <div>
                    <div>
                      <h6 className="m-0">📅 Register before:</h6>
                      <p className="px-4 fs-13">
                        {dateFormated(data.registrationDeadline)}
                      </p>
                    </div>
                    <div>
                      <h6 className="m-0">🕙 Submit before:</h6>
                      <p className="px-4 fs-13">
                        {dateFormated(data.submissionDeadline)}
                      </p>
                    </div>
                  </div>
                  <div>
                    <h6
                      className="py-2 mx-4 font-w600"
                      style={{ color: "rgb(45, 138, 184)" }}
                    >
                      Registration{" "}
                      {data.phase === "registration" ? "Opened" : "Closed"}
                    </h6>
                    <div
                      className="mx-2 mb-3 border-0 d-flex"
                      style={{ flexDirection: "column" }}
                    >
                      {isUserRegistered ? (
                        <>
                          <div
                            className="btn btn-secondary px-5 mb-2 fs-14"
                            style={{
                              backgroundColor: "#40a41c",
                              cursor: "default",
                              borderColor: "#40a41c",
                            }}
                          >
                            <span
                              className="fs-14"
                              style={{ fontWeight: "bold" }}
                            >
                              ALREADY REGISTERED
                            </span>
                          </div>
                        </>
                      ) : (
                        <>
                          {(data.phase === "registration" ||
                            (data.type === "race" &&
                              data.phase !== "review" &&
                              data.phase !== "ended" &&
                              data.phase !== "referred")) && (
                            <Link
                              className={`btn btn-secondary px-5 mb-2 fs-14 ${
                                isRamadan && "ramadan-button"
                              }`}
                              to={`/quest-registration/${id}`}
                            >
                              {isRamadan && <div></div>}
                              <span
                                className="fs-14"
                                style={{ fontWeight: "bold" }}
                              >
                                REGISTER NOW{" "}
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width="20"
                                  height="20"
                                  fill="currentColor"
                                  className="bi bi-arrow-right ms-2"
                                  viewBox="0 0 16 16"
                                >
                                  <path
                                    fillRule="evenodd"
                                    d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                                  />
                                </svg>
                              </span>
                            </Link>
                          )}
                        </>
                      )}

                      {(data.phase === "submission" ||
                        (data.type === "race" &&
                          data.phase !== "review" &&
                          data.phase !== "ended" &&
                          data.phase !== "referred")) && (
                        <Link
                          className={`btn btn-primary mb-2 fs-14 ${
                            isRamadan && "ramadan-button"
                          }`}
                          to={`/quest-submission/${id}`}
                        >
                          {isRamadan && <div></div>}
                          <span
                            className="fs-14"
                            style={{ fontWeight: "bold" }}
                          >
                            SUBMIT{" "}
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              fill="currentColor"
                              className="bi bi-arrow-right ms-2"
                              viewBox="0 0 16 16"
                            >
                              <path
                                fillRule="evenodd"
                                d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                              />
                            </svg>
                          </span>
                        </Link>
                      )}
                      <div></div>
                    </div>
                    <div>
                      <h4>📈 Challenge Statistics</h4>
                      {isAdmin ? (
                        <>
                          <Link to={`/quest-registrations/${id}`}>
                            <h6 className="a-style">
                              {" "}
                              🙋‍♀️Registrations: {data.registrationsCount}
                            </h6>
                          </Link>
                          <Link
                            className="a-style"
                            to={`/quest-submissions/${id}`}
                          >
                            <h6 className="m-0  a-style">
                              📦 Submissions: {data.submissionsCount}
                            </h6>
                          </Link>
                        </>
                      ) : (
                        <>
                          <p className="px-4 fs-14 m-0">
                            {" "}
                            🙋‍♀️Registrations: {data.registrationsCount}
                          </p>
                          <p className="px-4 fs-14">
                            {" "}
                            📦 Submissions: {data.submissionsCount}
                          </p>
                        </>
                      )}
                      {/* <p>Updated every night </p> */}
                    </div>
                    <div>
                      <h4>🗒️ Challenge Details</h4>
                      <p className="m-0" style={{ fontSize: "1rem" }}>
                        💪🏼 Difficulty: Intermediate
                      </p>
                      {/* <p className="px-4 fs-14">💯 Evaluation Criteria:</p>
                      <a
                        href={data.evaluationCriteriaLink}
                        rel="noopener noreferrer"
                        target="_blank"
                        className="mx-4 text-decoration-underline"
                        style={{ color: "rgb(45, 138, 184)" }}
                      >
                        {" "}
                        Scorecard{" "}
                      </a> */}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="details">
            <div className="card">
              <div className="card-header d-flex align-items-center justify-content-start gap-5 flex-wrap">
                <h3>{data.title}</h3>
              </div>
              {/* <div className="card-body pb-0"  dangerouslySetInnerHTML={{__html: data.description}}> */}
              <div className="card-body pb-0">
                {/*Description Container*/}
                <h4 className="fs-20 mb-3">Description</h4>
                <div
                  className="ms-4"
                  dangerouslySetInnerHTML={{ __html: data.description }}
                >
                  {/* {data.description.split(".").map((sentence, index) => (
                        <p key={index} className="mb-1">
                          {sentence}.
                        </p>
                      ))} */}
                </div>
                <hr />
                <div className="tasks">
                  <TaskSection data={data.tasks} header={"Tasks"} />
                  <TaskSection
                    data={data.acceptanceCriteria}
                    header={"Acceptance Criteria"}
                  />
                  <TaskSection
                    data={data.requirements}
                    header={"Requirements"}
                  />
                </div>
              </div>
              <div className="card-footer border-0">
                {!isUserRegistered && (data.phase === "registration" ||
                  (data.type === "race" &&
                    data.phase !== "review" &&
                    data.phase !== "ended" &&
                    data.phase !== "referred")) && (
                  <Link
                    className={`btn btn-secondary px-5 mb-2 fs-14 ${
                      isRamadan && "ramadan-button"
                    }`}
                    to={`/quest-registration/${id}`}
                  >
                    {isRamadan && <div></div>}
                    <span className="fs-14" style={{ fontWeight: "bold" }}>
                      REGISTER NOW{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-arrow-right ms-2"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg>
                    </span>
                  </Link>
                )}
                {(data.phase === "submission" || (data.type === "race" && data.phase !== "review" && data.phase !== "ended" &&
                    data.phase !== "referred")) && (
                  <Link
                    className={`btn btn-primary mb-2 fs-14 ${
                      isRamadan && "ramadan-button"
                    }`}
                    style={{ padding: "10px 48px", marginLeft: "10px" }}
                    to={`/quest-submission/${id}`}
                  >
                    {isRamadan && <div></div>}
                    <span className="fs-14" style={{ fontWeight: "bold" }}>
                      SUBMIT{" "}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="20"
                        height="20"
                        fill="currentColor"
                        className="bi bi-arrow-right ms-2"
                        viewBox="0 0 16 16"
                      >
                        <path
                          fillRule="evenodd"
                          d="M1 8a.5.5 0 0 1 .5-.5h11.793l-3.147-3.146a.5.5 0 0 1 .708-.708l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 0 1-.708-.708L13.293 8.5H1.5A.5.5 0 0 1 1 8z"
                        />
                      </svg>
                    </span>
                  </Link>
                )}
                <div></div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default QuestView;
